import { useEffect, useMemo } from 'react'
import { Link, useParams } from 'react-router-dom'
import {ArrowRight, CheckCircle2, GraduationCap} from 'lucide-react'
import {
  CURSOS_AROMATERAPIA,
  isCursoAromaterapiaId,
} from '@/data/cursosAromaterapia'

function CursoAromaterapiaLanding() {
  const { cursoId } = useParams()
  const curso = isCursoAromaterapiaId(cursoId) ? CURSOS_AROMATERAPIA[cursoId] : null

  const indicadoPor = useMemo(() => {
    const params = new URLSearchParams(window.location.search)
    return params.get('indicado_por')?.trim() || ''
  }, [])

  useEffect(() => {
    window.scrollTo(0, 0)
    if (indicadoPor) {
      try {
        sessionStorage.setItem('capacitacao_indicado_por', indicadoPor)
      } catch {
        // ignore
      }
    }
  }, [indicadoPor])

  if (!curso) {
    return (
      <div className="min-h-screen bg-[#F8F4EF] flex items-center justify-center px-4">
        <div className="max-w-md w-full bg-white rounded-3xl p-8 border border-[#EDE0D4] text-center">
          <h1 className="font-cormorant text-2xl font-semibold text-[#2C2C2A] mb-3">
            Curso não encontrado
          </h1>
          <p className="text-[#5F5E5A] mb-6">Este link de curso não está disponível.</p>
          <Link to="/" className="text-[#2D6A4F] font-medium hover:underline">
            Voltar ao início
          </Link>
        </div>
      </div>
    )
  }

  const qs = new URLSearchParams()
  if (indicadoPor) qs.set('indicado_por', indicadoPor)
  const linkInscricao = `/cursos/${curso.id}/inscricao${qs.toString() ? `?${qs.toString()}` : ''}`

  return (
    <div className="min-h-screen bg-[#F8F4EF]">
      <header className="bg-white border-b border-[#EDE0D4] sticky top-0 z-30">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 py-4">
          <p className="font-cormorant text-lg sm:text-xl font-semibold text-[#2D6A4F]">
            Diagnóstico Saúde e Emoções
          </p>
        </div>
      </header>

      <section className="px-4 sm:px-6 pt-12 sm:pt-20 pb-10">
        <div className="max-w-3xl mx-auto text-center">
          <span className="inline-block px-4 py-1.5 rounded-full bg-[#D8F3DC] text-[#2D6A4F] text-xs sm:text-sm font-medium mb-6">
            {curso.badge}
          </span>
          <h1 className="font-cormorant text-4xl sm:text-5xl font-semibold text-[#2C2C2A] leading-[1.1] mb-5">
            {curso.titulo}
          </h1>
          <p className="text-base sm:text-lg text-[#5F5E5A] leading-relaxed mb-8">
            {curso.subtitulo}
          </p>
          <Link
            to={linkInscricao}
            className="inline-flex items-center gap-2 bg-[#2D6A4F] text-white text-base sm:text-lg font-medium px-8 py-4 rounded-full hover:bg-[#1f4f3a] transition-all shadow-lg"
          >
            Quero me inscrever gratuitamente
            <ArrowRight size={20} />
          </Link>
        </div>
      </section>

      <section className="px-4 sm:px-6 pb-12">
        <div className="max-w-3xl mx-auto space-y-4">
          {curso.intro.map((texto) => (
            <p key={texto} className="text-[#5F5E5A] leading-relaxed text-center sm:text-left">
              {texto}
            </p>
          ))}
        </div>
      </section>

      <section className="px-4 sm:px-6 pb-12">
        <div className="max-w-3xl mx-auto bg-white rounded-3xl p-6 sm:p-8 border border-[#EDE0D4] shadow-sm">
          <div className="flex items-center gap-3 mb-6">
            <GraduationCap className="text-[#52B788]" size={24} />
            <h2 className="font-cormorant text-2xl font-semibold text-[#2C2C2A]">
              O que você vai aprender
            </h2>
          </div>
          <ul className="space-y-3">
            {curso.topicos.map((item) => (
              <li key={item} className="flex items-start gap-3">
                <CheckCircle2 className="text-[#52B788] shrink-0 mt-0.5" size={20} />
                <span className="text-[#2C2C2A] text-sm sm:text-base leading-relaxed">{item}</span>
              </li>
            ))}
          </ul>
          {curso.incluso ? (
            <p className="mt-6 text-sm text-[#2D6A4F] bg-[#D8F3DC] rounded-xl px-4 py-3">
              Incluso: {curso.incluso}
            </p>
          ) : null}
        </div>
      </section>

      <section className="px-4 sm:px-6 pb-16">
        <div className="max-w-3xl mx-auto text-center">
          <Link
            to={linkInscricao}
            className="inline-flex items-center gap-2 bg-[#2D6A4F] text-white text-base font-medium px-8 py-4 rounded-full hover:bg-[#1f4f3a] transition-all"
          >
            Quero me inscrever gratuitamente
            <ArrowRight size={20} />
          </Link>
        </div>
      </section>

      <footer className="py-8 text-center text-xs sm:text-sm text-[#5F5E5A]">
        © {new Date().getFullYear()} Diagnóstico Saúde e Emoções · Mônica Maria
      </footer>
    </div>
  )
}

export default CursoAromaterapiaLanding
